module.exports = __webpack_public_path__ + "static/media/Viking (Series 4).0efcb6f1.jpg";